import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import { EstateType } from '@/modules/estate/enums/EstateType';
import { ClearVaultContactRelationshipType } from '@/modules/contact/enums/ClearVaultContactRelationshipType';
import { ClearEstateContactRelationshipType } from '@/modules/contact/enums/ClearEstateContactRelationshipType';

export class ContactRelationship extends BaseEntityModel {
  childId?: number;
  parentId?: number;
  relationshipType?: string;
  relationshipDescription?: string;
  isInCustodySinceBirth?: boolean;
  custodyStartDate?: string;
  isStillInCustody?: boolean;
  isStillInCustodyExplanation?: string;

  constructor(model: Partial<ContactRelationship> = {}) {
    super(model);

    this.childId = model.childId;
    this.parentId = model.parentId;
    this.relationshipType = model.relationshipType;
    this.relationshipDescription = model.relationshipDescription;
    this.isInCustodySinceBirth = model.isInCustodySinceBirth;
    this.custodyStartDate = model.custodyStartDate;
    this.isStillInCustody = model.isStillInCustody;
    this.isStillInCustodyExplanation = model.isStillInCustodyExplanation;
  }

  getDisplayRelationshipByEstateType(type: string): string {
    let relationship:
      | ClearEstateContactRelationshipType
      | ClearVaultContactRelationshipType
      | undefined;

    switch (type) {
      case EstateType.CLEAR_VAULT.key:
        relationship = ClearVaultContactRelationshipType.getByKey(this.relationshipType as string);

        return relationship
          ? relationship.displayValue
          : ClearVaultContactRelationshipType.OTHER.displayValue;
      case EstateType.CLEAR_ESTATE.key:
      default:
        relationship = ClearEstateContactRelationshipType.getByKey(this.relationshipType as string);

        return relationship
          ? relationship.displayValue
          : ClearEstateContactRelationshipType.OTHER.displayValue;
    }
  }
}
